import CustomReactSelect, { Option } from 'components/custom/CustomReactSelect';
import { useSettings } from 'contexts/SettingsContextUtils';
import { getTranslatedString } from 'helpers/utils-typescript';
import React from 'react';
import { useIntl } from 'react-intl';
import { ContributionType } from 'services/graphqltypes';

export type ProjectWorkType = Pick<ContributionType, 'id' | 'name' | 'ipCategory'>;

type Props = {
  id: string;
  types: ProjectWorkType[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  isMulti?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  describedBy?: string;
};

const ContributionWorkTypeSelect = ({ id, types, selectedIds, onChange, isMulti = true, disabled, invalid, describedBy }: Props): React.ReactElement => {
  const intl = useIntl();
  const { locale } = useSettings();
  const options: Option[] = types.map((type) => ({
    value: type.id,
    label: intl.formatMessage({ id: 'community.contribution-projects.work-type-option' }, {
      name: getTranslatedString(type.name, locale),
      category: intl.formatMessage({ id: `community.contribution-projects.category.${type.ipCategory}` })
    })
  }));
  return (
    <CustomReactSelect
      name={id}
      inputId={id}
      options={options}
      selected={isMulti ? options.filter((option) => selectedIds.includes(option.value))
        : options.find((option) => selectedIds.includes(option.value)) ?? null}
      isMulti={isMulti}
      isDisabled={disabled}
      aria-invalid={invalid}
      aria-describedby={describedBy}
      placeholder={intl.formatMessage({ id: 'general.select-or-type-to-search' })}
      handleChange={(selection: readonly Option[] | Option | null) => {
        const choices = selection ? (Array.isArray(selection) ? selection : [selection as Option]) : [];
        onChange(choices.map((choice) => choice.value));
      }}
    />
  );
};

export default ContributionWorkTypeSelect;
